export default "__VITE_ASSET__j98ykk7S__"